import fetch from 'lib/fetch'
import { PopularPumpsResponse } from 'bl-health/types/responses/popular-pumps-response'
import { RequestMethod } from './RequestMethod'
import { POPULAR_PUMPS_ENDPOINT } from './constants'

export default function getPopularPumps(): Promise<PopularPumpsResponse> {
  return fetch(POPULAR_PUMPS_ENDPOINT, {
    method: RequestMethod.GET,
  })
}
